import {
  RECEIVE_ENTERPRISE_LIST,
  RECEIVE_ENTERPRISE_INFO,
  RECEIVE_ENTERPRISE_USERS,
  RECEIVE_IMPERSONATED_USERS,
  RECEIVE_ENTERPRISE_ROLES,
  RECEIVE_USER_INFO,
  CLEAR_ENTERPRISE_USERS,
  CLEAR_ENTERPRISE_INFO,
  INVITE_USER,
  STAGE_USER_FOR_DELETE,
  UNSTAGE_USERS_FOR_DELETE,
  DELETE_USER,
} from '../constants/ActionTypes';

const enterpriseMaintenance = (state = {
  list: [],
  detail: {},
  users: [],
  impersonatedUsers: [],
  userDetail: {},
}, action) => {
  switch (action.type) {
    case RECEIVE_ENTERPRISE_LIST:
      return {
        ...state,
        list: action.data,
      }
    case RECEIVE_ENTERPRISE_INFO:
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.data,
        }
      }
    case RECEIVE_ENTERPRISE_ROLES:
      return {
        ...state,
        detail: {
          ...state.detail,
          __Roles: action.data,
        }
      }
    case RECEIVE_ENTERPRISE_USERS:
      return {
        ...state,
        users: action.data,
      }
    case RECEIVE_IMPERSONATED_USERS:
      return {
        ...state,
        impersonatedUsers: action.data,
      }
    case RECEIVE_USER_INFO:
      return {
        ...state,
        userDetail: action.data, 
      }
    case CLEAR_ENTERPRISE_USERS:
      return {
        ...state,
        userDetail: {},
        users: [],
      }
    case CLEAR_ENTERPRISE_INFO:
      return {
        ...state,
        detail: {},
      }
    case INVITE_USER:
      const invitedUsers = state.users.map((user) => {
        if (user.userGUID === action.userGUID) {
          return {
            ...user,
            userVerificationCode: action.userVerificationCode,
          };
        } else {
          return user;
        }
      });
      return {
        ...state,
        users: invitedUsers,
      }
    case STAGE_USER_FOR_DELETE:
      const stagedUsers = state.users.map((user) => {
        if (user.userGUID === action.userGUID) {
          return {
            ...user,
            isStagedForDelete: true,
            isClearedForDelete: action.isClearedForDelete,
          };
        }
        return user;
      });
      return {
        ...state,
        users: stagedUsers,
      }
    case UNSTAGE_USERS_FOR_DELETE:
      const unstagedUsers = state.users.map((user) => {
        if (user.isStagedForDelete) {
          delete user.isStagedForDelete;
          delete user.isClearedForDelete;
        }
        return user;
      });
      return {
        ...state,
        users: unstagedUsers,
      }
    case DELETE_USER:
      const surviving = state.users.filter((user) => user.userGUID !== action.userGUID);
      return {
        ...state,
        users: surviving,
      }
    default:
      return state;
  }
}

export default enterpriseMaintenance;



// WEBPACK FOOTER //
// ./src/reducers/enterpriseMaintenance.js